import React, { createContext, useContext, useState, useEffect } from 'react';

// Traducciones
const translations = {
  es: {
    // General
    'app.loading': 'Cargando...',
    'app.error': 'Error',
    'app.save': 'Guardar',
    'app.cancel': 'Cancelar',
    'app.delete': 'Eliminar',
    'app.edit': 'Editar',
    'app.create': 'Crear',
    'app.search': 'Buscar',
    'app.filter': 'Filtrar',
    'app.close': 'Cerrar',
    'app.confirm': 'Confirmar',
    'app.yes': 'Si',
    'app.no': 'No',
    'app.back': 'Volver',
    'app.next': 'Siguiente',
    'app.previous': 'Anterior',
    'app.all': 'Todos',
    'app.none': 'Ninguno',
    'app.select': 'Seleccionar',
    'app.noResults': 'Sin resultados',
    'app.required': 'Requerido',
    'app.optional': 'Opcional',

    // Auth
    'auth.login': 'Iniciar sesion',
    'auth.logout': 'Cerrar sesion',
    'auth.email': 'Email',
    'auth.password': 'Contrasena',
    'auth.forgotPassword': 'Olvide mi contrasena',
    'auth.invalidCredentials': 'Credenciales invalidas',
    'auth.sessionExpired': 'Sesion expirada',

    // Navigation
    'nav.dashboard': 'Panel',
    'nav.chat': 'Chat',
    'nav.users': 'Usuarios',
    'nav.tickets': 'Incidencias',
    'nav.knowledge': 'Conocimiento IA',
    'nav.devices': 'Datos Aparatos',
    'nav.files': 'Archivos',
    'nav.settings': 'Configuracion',
    'nav.notifications': 'Notificaciones',
    'nav.externalChats': 'Chats Externos',

    // Chat
    'chat.writeMessage': 'Escribe un mensaje...',
    'chat.send': 'Enviar',
    'chat.typing': 'Escribiendo...',
    'chat.today': 'Hoy',
    'chat.yesterday': 'Ayer',
    'chat.noMessages': 'No hay mensajes',
    'chat.calendar': 'Calendario',
    'chat.tasks': 'Tareas',
    'chat.noTasks': 'No hay tareas pendientes',
    'chat.completeTask': 'Completar tarea',

    // Tickets
    'tickets.title': 'Incidencias',
    'tickets.new': 'Nueva incidencia',
    'tickets.open': 'Abierto',
    'tickets.assigned': 'Asignado',
    'tickets.inProgress': 'En progreso',
    'tickets.resolved': 'Resuelto',
    'tickets.closed': 'Cerrado',
    'tickets.priority': 'Prioridad',
    'tickets.critical': 'Critica',
    'tickets.high': 'Alta',
    'tickets.medium': 'Media',
    'tickets.low': 'Baja',
    'tickets.category': 'Categoria',
    'tickets.assignee': 'Asignado a',
    'tickets.created': 'Creado',
    'tickets.updated': 'Actualizado',
    'tickets.comments': 'Comentarios',
    'tickets.addComment': 'Agregar comentario',
    'tickets.internalNote': 'Nota interna',

    // Users
    'users.title': 'Usuarios',
    'users.newUser': 'Nuevo usuario',
    'users.name': 'Nombre',
    'users.email': 'Email',
    'users.role': 'Rol',
    'users.department': 'Departamento',
    'users.status': 'Estado',
    'users.active': 'Activo',
    'users.blocked': 'Bloqueado',
    'users.lastLogin': 'Ultimo acceso',
    'users.resetPassword': 'Restablecer contrasena',
    'users.block': 'Bloquear',
    'users.unblock': 'Desbloquear',

    // Roles
    'roles.superadmin': 'Super Administrador',
    'roles.admin': 'Administrador',
    'roles.reviewer': 'Revisor',
    'roles.employee': 'Usuario',
    'roles.location': 'Lugar',
    'roles.franchisee': 'Franquiciado',
    'roles.endClient': 'Cliente Final',

    // Knowledge
    'knowledge.title': 'Base de Conocimiento',
    'knowledge.newArticle': 'Nuevo articulo',
    'knowledge.searchPlaceholder': 'Buscar articulos...',
    'knowledge.category': 'Categoria',
    'knowledge.tags': 'Etiquetas',
    'knowledge.content': 'Contenido',
    'knowledge.forAI': 'Usar para IA',
    'knowledge.public': 'Publico',

    // Devices
    'devices.title': 'Aparatos',
    'devices.import': 'Importar CSV',
    'devices.search': 'Buscar aparatos...',
    'devices.type': 'Tipo',
    'devices.location': 'Ubicacion',
    'devices.hasPinpad': 'Tiene Pinpad',
    'devices.total': 'Total',
    'devices.lastUpdate': 'Ultima actualizacion',

    // Files
    'files.title': 'Archivos',
    'files.upload': 'Subir archivo',
    'files.download': 'Descargar',
    'files.delete': 'Eliminar',
    'files.folder': 'Carpeta',
    'files.newFolder': 'Nueva carpeta',
    'files.size': 'Tamano',
    'files.modified': 'Modificado',

    // Shipments
    'shipments.title': 'Envios y Recibos',
    'shipments.newShipment': 'Nuevo envio',
    'shipments.newReceipt': 'Nuevo recibo',
    'shipments.description': 'Descripcion',
    'shipments.destination': 'Destino',
    'shipments.quantity': 'Cantidad',
    'shipments.tracking': 'N° Seguimiento',

    // AI
    'ai.title': 'Xavia',
    'ai.subtitle': 'Tu asistente inteligente',
    'ai.greeting': 'Hola! Soy Xavia, tu asistente de Manantial. ¿En que puedo ayudarte hoy?',
    'ai.disclaimer': 'Xavia puede cometer errores. Verifica la informacion importante.',
    'ai.newConversation': 'Nueva conversacion',

    // Settings
    'settings.title': 'Configuracion',
    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.notifications': 'Notificaciones',
    'settings.profile': 'Perfil',
    'settings.changePassword': 'Cambiar contrasena',

    // Errors
    'error.network': 'Error de conexion',
    'error.server': 'Error del servidor',
    'error.notFound': 'No encontrado',
    'error.forbidden': 'Sin permisos',
    'error.unauthorized': 'No autorizado',
    'error.validation': 'Error de validacion',
  },

  en: {
    // General
    'app.loading': 'Loading...',
    'app.error': 'Error',
    'app.save': 'Save',
    'app.cancel': 'Cancel',
    'app.delete': 'Delete',
    'app.edit': 'Edit',
    'app.create': 'Create',
    'app.search': 'Search',
    'app.filter': 'Filter',
    'app.close': 'Close',
    'app.confirm': 'Confirm',
    'app.yes': 'Yes',
    'app.no': 'No',
    'app.back': 'Back',
    'app.next': 'Next',
    'app.previous': 'Previous',
    'app.all': 'All',
    'app.none': 'None',
    'app.select': 'Select',
    'app.noResults': 'No results',
    'app.required': 'Required',
    'app.optional': 'Optional',

    // Auth
    'auth.login': 'Log in',
    'auth.logout': 'Log out',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.forgotPassword': 'Forgot my password',
    'auth.invalidCredentials': 'Invalid credentials',
    'auth.sessionExpired': 'Session expired',

    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.chat': 'Chat',
    'nav.users': 'Users',
    'nav.tickets': 'Tickets',
    'nav.knowledge': 'AI Knowledge',
    'nav.devices': 'Devices Data',
    'nav.files': 'Files',
    'nav.settings': 'Settings',
    'nav.notifications': 'Notifications',
    'nav.externalChats': 'External Chats',

    // Chat
    'chat.writeMessage': 'Write a message...',
    'chat.send': 'Send',
    'chat.typing': 'Typing...',
    'chat.today': 'Today',
    'chat.yesterday': 'Yesterday',
    'chat.noMessages': 'No messages',
    'chat.calendar': 'Calendar',
    'chat.tasks': 'Tasks',
    'chat.noTasks': 'No pending tasks',
    'chat.completeTask': 'Complete task',

    // Tickets
    'tickets.title': 'Tickets',
    'tickets.new': 'New ticket',
    'tickets.open': 'Open',
    'tickets.assigned': 'Assigned',
    'tickets.inProgress': 'In progress',
    'tickets.resolved': 'Resolved',
    'tickets.closed': 'Closed',
    'tickets.priority': 'Priority',
    'tickets.critical': 'Critical',
    'tickets.high': 'High',
    'tickets.medium': 'Medium',
    'tickets.low': 'Low',
    'tickets.category': 'Category',
    'tickets.assignee': 'Assigned to',
    'tickets.created': 'Created',
    'tickets.updated': 'Updated',
    'tickets.comments': 'Comments',
    'tickets.addComment': 'Add comment',
    'tickets.internalNote': 'Internal note',

    // Users
    'users.title': 'Users',
    'users.newUser': 'New user',
    'users.name': 'Name',
    'users.email': 'Email',
    'users.role': 'Role',
    'users.department': 'Department',
    'users.status': 'Status',
    'users.active': 'Active',
    'users.blocked': 'Blocked',
    'users.lastLogin': 'Last login',
    'users.resetPassword': 'Reset password',
    'users.block': 'Block',
    'users.unblock': 'Unblock',

    // Roles
    'roles.superadmin': 'Super Administrator',
    'roles.admin': 'Administrator',
    'roles.reviewer': 'Reviewer',
    'roles.employee': 'Employee',
    'roles.location': 'Location',
    'roles.franchisee': 'Franchisee',
    'roles.endClient': 'End Client',

    // Knowledge
    'knowledge.title': 'Knowledge Base',
    'knowledge.newArticle': 'New article',
    'knowledge.searchPlaceholder': 'Search articles...',
    'knowledge.category': 'Category',
    'knowledge.tags': 'Tags',
    'knowledge.content': 'Content',
    'knowledge.forAI': 'Use for AI',
    'knowledge.public': 'Public',

    // Devices
    'devices.title': 'Devices',
    'devices.import': 'Import CSV',
    'devices.search': 'Search devices...',
    'devices.type': 'Type',
    'devices.location': 'Location',
    'devices.hasPinpad': 'Has Pinpad',
    'devices.total': 'Total',
    'devices.lastUpdate': 'Last update',

    // Files
    'files.title': 'Files',
    'files.upload': 'Upload file',
    'files.download': 'Download',
    'files.delete': 'Delete',
    'files.folder': 'Folder',
    'files.newFolder': 'New folder',
    'files.size': 'Size',
    'files.modified': 'Modified',

    // Shipments
    'shipments.title': 'Shipments and Receipts',
    'shipments.newShipment': 'New shipment',
    'shipments.newReceipt': 'New receipt',
    'shipments.description': 'Description',
    'shipments.destination': 'Destination',
    'shipments.quantity': 'Quantity',
    'shipments.tracking': 'Tracking #',

    // AI
    'ai.title': 'Xavia',
    'ai.subtitle': 'Your intelligent assistant',
    'ai.greeting': 'Hi! I\'m Xavia, your Manantial assistant. How can I help you today?',
    'ai.disclaimer': 'Xavia may make mistakes. Verify important information.',
    'ai.newConversation': 'New conversation',

    // Settings
    'settings.title': 'Settings',
    'settings.language': 'Language',
    'settings.theme': 'Theme',
    'settings.notifications': 'Notifications',
    'settings.profile': 'Profile',
    'settings.changePassword': 'Change password',

    // Errors
    'error.network': 'Network error',
    'error.server': 'Server error',
    'error.notFound': 'Not found',
    'error.forbidden': 'Forbidden',
    'error.unauthorized': 'Unauthorized',
    'error.validation': 'Validation error',
  },

  fr: {
    // General
    'app.loading': 'Chargement...',
    'app.error': 'Erreur',
    'app.save': 'Enregistrer',
    'app.cancel': 'Annuler',
    'app.delete': 'Supprimer',
    'app.edit': 'Modifier',
    'app.create': 'Creer',
    'app.search': 'Rechercher',
    'app.filter': 'Filtrer',
    'app.close': 'Fermer',
    'app.confirm': 'Confirmer',
    'app.yes': 'Oui',
    'app.no': 'Non',
    'app.back': 'Retour',
    'app.next': 'Suivant',
    'app.previous': 'Precedent',
    'app.all': 'Tous',
    'app.none': 'Aucun',
    'app.select': 'Selectionner',
    'app.noResults': 'Aucun resultat',
    'app.required': 'Requis',
    'app.optional': 'Optionnel',

    // Auth
    'auth.login': 'Se connecter',
    'auth.logout': 'Se deconnecter',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.forgotPassword': 'Mot de passe oublie',
    'auth.invalidCredentials': 'Identifiants invalides',
    'auth.sessionExpired': 'Session expiree',

    // Navigation
    'nav.dashboard': 'Tableau de bord',
    'nav.chat': 'Chat',
    'nav.users': 'Utilisateurs',
    'nav.tickets': 'Tickets',
    'nav.knowledge': 'Base IA',
    'nav.devices': 'Appareils',
    'nav.files': 'Fichiers',
    'nav.settings': 'Parametres',
    'nav.notifications': 'Notifications',
    'nav.externalChats': 'Chats Externes',

    // Chat
    'chat.writeMessage': 'Ecrire un message...',
    'chat.send': 'Envoyer',
    'chat.typing': 'En train d\'ecrire...',
    'chat.today': 'Aujourd\'hui',
    'chat.yesterday': 'Hier',
    'chat.noMessages': 'Pas de messages',
    'chat.calendar': 'Calendrier',
    'chat.tasks': 'Taches',
    'chat.noTasks': 'Pas de taches en attente',
    'chat.completeTask': 'Completer la tache',

    // Tickets
    'tickets.title': 'Tickets',
    'tickets.new': 'Nouveau ticket',
    'tickets.open': 'Ouvert',
    'tickets.assigned': 'Assigne',
    'tickets.inProgress': 'En cours',
    'tickets.resolved': 'Resolu',
    'tickets.closed': 'Ferme',
    'tickets.priority': 'Priorite',
    'tickets.critical': 'Critique',
    'tickets.high': 'Haute',
    'tickets.medium': 'Moyenne',
    'tickets.low': 'Basse',
    'tickets.category': 'Categorie',
    'tickets.assignee': 'Assigne a',
    'tickets.created': 'Cree',
    'tickets.updated': 'Mis a jour',
    'tickets.comments': 'Commentaires',
    'tickets.addComment': 'Ajouter un commentaire',
    'tickets.internalNote': 'Note interne',

    // Users
    'users.title': 'Utilisateurs',
    'users.newUser': 'Nouvel utilisateur',
    'users.name': 'Nom',
    'users.email': 'Email',
    'users.role': 'Role',
    'users.department': 'Departement',
    'users.status': 'Statut',
    'users.active': 'Actif',
    'users.blocked': 'Bloque',
    'users.lastLogin': 'Derniere connexion',
    'users.resetPassword': 'Reinitialiser le mot de passe',
    'users.block': 'Bloquer',
    'users.unblock': 'Debloquer',

    // Roles
    'roles.superadmin': 'Super Administrateur',
    'roles.admin': 'Administrateur',
    'roles.reviewer': 'Reviseur',
    'roles.employee': 'Employe',
    'roles.location': 'Lieu',
    'roles.franchisee': 'Franchise',
    'roles.endClient': 'Client Final',

    // AI
    'ai.title': 'Xavia',
    'ai.subtitle': 'Votre assistant intelligent',
    'ai.greeting': 'Bonjour! Je suis Xavia, votre assistant Manantial. Comment puis-je vous aider?',
    'ai.disclaimer': 'Xavia peut faire des erreurs. Verifiez les informations importantes.',
    'ai.newConversation': 'Nouvelle conversation',

    // Settings
    'settings.title': 'Parametres',
    'settings.language': 'Langue',
    'settings.theme': 'Theme',
    'settings.notifications': 'Notifications',
    'settings.profile': 'Profil',
    'settings.changePassword': 'Changer le mot de passe',

    // Errors
    'error.network': 'Erreur reseau',
    'error.server': 'Erreur serveur',
    'error.notFound': 'Non trouve',
    'error.forbidden': 'Interdit',
    'error.unauthorized': 'Non autorise',
    'error.validation': 'Erreur de validation',
  },

  pt: {
    // General
    'app.loading': 'Carregando...',
    'app.error': 'Erro',
    'app.save': 'Salvar',
    'app.cancel': 'Cancelar',
    'app.delete': 'Excluir',
    'app.edit': 'Editar',
    'app.create': 'Criar',
    'app.search': 'Buscar',
    'app.filter': 'Filtrar',
    'app.close': 'Fechar',
    'app.confirm': 'Confirmar',
    'app.yes': 'Sim',
    'app.no': 'Nao',
    'app.back': 'Voltar',
    'app.next': 'Proximo',
    'app.previous': 'Anterior',
    'app.all': 'Todos',
    'app.none': 'Nenhum',
    'app.select': 'Selecionar',
    'app.noResults': 'Sem resultados',
    'app.required': 'Obrigatorio',
    'app.optional': 'Opcional',

    // Auth
    'auth.login': 'Entrar',
    'auth.logout': 'Sair',
    'auth.email': 'Email',
    'auth.password': 'Senha',
    'auth.forgotPassword': 'Esqueci minha senha',
    'auth.invalidCredentials': 'Credenciais invalidas',
    'auth.sessionExpired': 'Sessao expirada',

    // Navigation
    'nav.dashboard': 'Painel',
    'nav.chat': 'Chat',
    'nav.users': 'Usuarios',
    'nav.tickets': 'Tickets',
    'nav.knowledge': 'Base IA',
    'nav.devices': 'Aparelhos',
    'nav.files': 'Arquivos',
    'nav.settings': 'Configuracoes',
    'nav.notifications': 'Notificacoes',
    'nav.externalChats': 'Chats Externos',

    // AI
    'ai.title': 'Xavia',
    'ai.subtitle': 'Seu assistente inteligente',
    'ai.greeting': 'Ola! Sou Xavia, seu assistente Manantial. Como posso ajudar?',
    'ai.disclaimer': 'Xavia pode cometer erros. Verifique informacoes importantes.',
    'ai.newConversation': 'Nova conversa',

    // Settings
    'settings.title': 'Configuracoes',
    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.notifications': 'Notificacoes',
    'settings.profile': 'Perfil',
    'settings.changePassword': 'Alterar senha',

    // Errors
    'error.network': 'Erro de rede',
    'error.server': 'Erro do servidor',
    'error.notFound': 'Nao encontrado',
    'error.forbidden': 'Proibido',
    'error.unauthorized': 'Nao autorizado',
    'error.validation': 'Erro de validacao',
  }
};

// Idiomas disponibles
export const availableLanguages = [
  { code: 'es', name: 'Espanol', flag: '🇪🇸' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Francais', flag: '🇫🇷' },
  { code: 'pt', name: 'Portugues', flag: '🇵🇹' }
];

// Contexto
const I18nContext = createContext();

// Provider
export function I18nProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Intentar obtener del localStorage
    const saved = localStorage.getItem('language');
    if (saved && translations[saved]) return saved;

    // Intentar detectar del navegador
    const browserLang = navigator.language.split('-')[0];
    if (translations[browserLang]) return browserLang;

    // Default: espanol
    return 'es';
  });

  // Guardar en localStorage cuando cambie
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Funcion para traducir
  const t = (key, params = {}) => {
    let text = translations[language]?.[key] || translations['es']?.[key] || key;

    // Reemplazar parametros {param}
    Object.keys(params).forEach(param => {
      text = text.replace(`{${param}}`, params[param]);
    });

    return text;
  };

  // Cambiar idioma
  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <I18nContext.Provider value={{ language, t, changeLanguage, availableLanguages }}>
      {children}
    </I18nContext.Provider>
  );
}

// Hook para usar traducciones
export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
}

export default I18nContext;
